import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Helmet } from "react-helmet-async";
import JoinNowFormPopup from "../../../componants/JoinNowFormPopup"; // Make sure the path is correct

// Helper component for Star Rating (reused)
const StarRating = ({ rating }: { rating: number }) => {
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    stars.push(
      <svg
        key={i}
        className={`h-4 w-4 ${
          i <= rating ? "text-yellow-400" : "text-gray-300"
        } inline-block`}
        fill="currentColor"
        viewBox="0 0 20 20"
      >
        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.538 1.118l-2.8-2.034a1 1 0 00-1.176 0l-2.8 2.034c-.783.57-1.838-.197-1.538-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.381-1.81.588-1.81h3.462a1 1 0 00.95-.69l1.07-3.292z" />
      </svg>
    );
  }
  return <div className="flex items-center">{stars}</div>;
};

// Helper component for Verified Badge (reused)
const VerifiedBadge = () => (
  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 ml-2">
    <svg
      className="w-3 h-3 mr-1"
      fill="currentColor"
      viewBox="0 0 20 20"
    >
      <path
        fillRule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clipRule="evenodd"
      />
    </svg>
    Verified
  </span>
);

const JavaCertification = () => {
  const testimonials = [
    {
      id: 1,
      name: "Saloni Jadaun",
      review:
        "Nadezhda Venture is the Best Training Institute in Noida! I recently completed my Java training here and the experience was exceptional. The instructors are highly knowledgeable, supportive, and make complex topics easy to understand. Hands-on projects gave me real-world experience, and the placement assistance was top-notch. Highly recommended for anyone looking to kickstart their career in IT.",
      rating: 5,
      date: "2024-07-31",
      profileImg: "https://www.kellogg.northwestern.edu/-/media/images/web2022/people/s/sonali-lamba/sonali-lamba-kellogg-faculty-874x728.ashx?sc_lang=en&hash=F5F3F53D7D81CC9CD04B71B0DE4A2E9A", // Placeholder image
    },
    {
      id: 2,
      name: "Ritu Jyala",
      review:
        "Nadezhda Venture is undoubtedly the best training institute in Noida for Java. I completed my internship here, and it significantly enhanced my Java skills. The practical approach, real-time projects, and consistent doubt clearing sessions were invaluable. I now feel confident in my programming abilities. Thank you, Nadezhda!",
      rating: 4,
      date: "2024-07-31",
      profileImg: "https://media.licdn.com/dms/image/v2/D5622AQHT3oimUQYjiQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1722867582269?e=2147483647&v=beta&t=oAvS6OGTQsG77VnfWdmZTzSxaN0deGrJ9PWnhsJWN64", // Placeholder image
    },
    {
      id: 3,
      name: "Ankit Yadav",
      review:
        "This is the Best Training Institute in Noida, I learned Java here, but they also offer other excellent courses like Python, Data Science, and more. The teaching methodology is superb, focusing on practical implementation. The mentors are always ready to help. A fantastic place to learn and grow!",
      rating: 4,
      date: "2024-07-31",
      profileImg: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQxfjSybtqpwO2m1dMWj7sUeD611m1ehTBNQw&s", // Placeholder image
    },
    {
      id: 4,
      name: "Srishti Arya",
      review:
        "I recently completed the Java course at Nadezhda Venture, and I couldn't be more satisfied with the experience. From the structured curriculum to the interactive sessions and practical assignments, everything was designed to ensure comprehensive learning. The support team is very responsive, and the overall environment is conducive to growth.",
      rating: 5,
      date: "2024-07-31",
      profileImg: "https://fadcdn.s3.ap-south-1.amazonaws.com/media/1526/Lead_image_85920.jpg", // Placeholder image
    },
    {
      id: 5,
      name: "Piyush Saini",
      review:
        "This is a very good platform for learning new technologies. The Java course was well-explained, and the instructors were very supportive. I gained a lot of practical knowledge here.",
      rating: 4,
      date: "2024-07-30",
      profileImg: "https://media.licdn.com/dms/image/v2/D4D03AQEDu7t80Ck3jA/profile-displayphoto-shrink_200_200/B4DZUJnksfHYAY-/0/1739623125676?e=2147483647&v=beta&t=7-oHBTBM6oTYgr7XGU6fN_3v8CcKs4CTks7iuDzhpe0", // Placeholder image
    },
  ];

  const [isPopupOpen, setIsPopupOpen] = useState(false); // State to control popup visibility
    const [selectedCourseTitle, setSelectedCourseTitle] = useState(""); // State to store the course title
  
    const handleOpenPopup = (courseTitle: string) => { // Function to open the popup
      setSelectedCourseTitle(courseTitle); // Set the selected course title
      setIsPopupOpen(true); // Open the popup
    };
  
    const handleClosePopup = () => { // Function to close the popup
      setIsPopupOpen(false); // Close the popup
      setSelectedCourseTitle(""); // Clear selected course when closing
    };

  const faqContent = [
    {
      title: "Introduction to Java: What is Java and why learn it?",
      answer:
        "Java is a high-level, class-based, object-oriented programming language designed to have as few implementation dependencies as possible. It's a general-purpose programming language intended to let application developers 'write once, run anywhere' (WORA), meaning that compiled Java code can run on all platforms that support Java without the need for recompilation. Learning Java opens doors to various career paths in enterprise-level applications, Android development, big data, and more.",
    },
    {
      title: "Data Types, Variables & Operators: How are data types used in Java?",
      answer:
        "In Java, data types specify the size and type of values that can be stored in variables. Primitive data types include `byte`, `short`, `int`, `long`, `float`, `double`, `boolean`, and `char`. Non-primitive types are classes, interfaces, and arrays. Variables are containers for storing data values. Operators are symbols that perform operations on variables and values.",
    },
    {
      title: "Control Flow Statements: What are control flow statements?",
      answer:
        "Control flow statements in Java dictate the order in which individual statements, instructions, or function calls are executed or evaluated. They allow your program to make decisions, execute code repeatedly, or jump to a different part of the code. Key control flow statements include `if-else`, `switch`, `for`, `while`, and `do-while` loops, and `break`/`continue` statements.",
    },
    {
      title: "Object-Oriented Programming (OOP): Explain OOP concepts in Java.",
      answer:
        "Java is built on Object-Oriented Programming (OOP) principles. The four main pillars of OOP are **Encapsulation** (bundling data and methods that operate on the data within a single unit or class), **Inheritance** (a mechanism where one class acquires the properties and behaviors of another class), **Polymorphism** (the ability of an object to take on many forms), and **Abstraction** (hiding the complex implementation details and showing only the necessary features of an object).",
    },
    {
      title: "Packages and Access Modifiers: Why are packages important?",
      answer:
        "Packages in Java are used to organize classes, interfaces, and sub-packages. They provide a way to group related types, helping to avoid naming conflicts and control access. Access modifiers (`public`, `private`, `protected`, `default`) define the visibility and accessibility of classes, methods, and variables within a program, ensuring proper encapsulation and data protection.",
    },
    {
      title: "Arrays and Strings: How do Arrays and Strings work in Java?",
      answer:
        "Arrays in Java are objects that store multiple variables of the same type in a contiguous memory location. They are fixed in size once initialized. Strings in Java are objects that represent sequences of characters. Unlike arrays, String objects are immutable, meaning their value cannot be changed after they are created. Java provides rich API for manipulating strings.",
    },
    {
      title: "Exception Handling: What is Exception Handling?",
      answer:
        "Exception handling in Java is a mechanism to manage runtime errors, allowing a program to terminate gracefully rather than crashing. It involves `try`, `catch`, `finally`, `throw`, and `throws` keywords. This structured approach helps in separating error-handling code from normal program logic, making the code more robust and readable.",
    },
    {
      title: "Wrapper Classes & Autoboxing: What are Wrapper Classes?",
      answer:
        "Wrapper classes in Java convert primitive data types into objects. For example, `int` becomes `Integer`, `char` becomes `Character`, etc. This is useful when working with collections, which can only store objects. Autoboxing is the automatic conversion of primitive types to their corresponding wrapper class objects by the Java compiler, and unboxing is the reverse.",
    },
    {
      title: "Collections Framework: What is the Java Collections Framework?",
      answer:
        "The Java Collections Framework is a set of interfaces and classes that represent groups of objects as a single unit. It provides a unified architecture for storing and manipulating groups of objects. Key interfaces include `List`, `Set`, and `Map`, with common implementations like `ArrayList`, `HashSet`, and `HashMap`. This framework makes it easier to work with data structures.",
    },
    {
      title: "Input/Output: How is I/O handled in Java?",
      answer:
        "Java's I/O (Input/Output) system allows programs to interact with external data sources, such as files, networks, or the console. It uses streams to read and write data. `InputStream` and `OutputStream` are used for byte streams, while `Reader` and `Writer` are used for character streams. Classes like `FileInputStream`, `FileOutputStream`, `BufferedReader`, and `PrintWriter` facilitate various I/O operations.",
    },
    {
      title: "How does the Java Certification process work?",
      answer:
        "Upon successful completion of the course modules, hands-on projects, and a final assessment, you will be awarded a **Java Developer Certificate** from Nadezhda Venture. This certificate validates your proficiency in Java programming and enhances your professional credibility in the IT industry.",
    },
    {
      title: "Is placement assistance provided after the Java certification?",
      answer:
        "Yes, we offer dedicated placement assistance to our certified Java developers. This includes resume building workshops, mock interview sessions, and connecting you with our network of hiring partners in Noida and across India to help you land your dream job as a Java developer.",
    },
  ];

  const certificationDetails = [
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          ></path>
        </svg>
      ),
      title: "Industry-Recognized Certification",
      description:
        "Receive a certificate that's valued by top tech companies, validating your Java expertise.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10 21h7a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          ></path>
        </svg>
      ),
      title: "Project-Based Learning",
      description:
        "Build a strong portfolio with multiple real-world Java projects throughout the course.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"
          ></path>
        </svg>
      ),
      title: "Comprehensive Core & Advanced Java",
      description:
        "Master Java from basics to advanced topics, including OOPs, Collections, and more.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c1.657 0 3 .895 3 2s-1.343 2-3 2-3-.895-3-2 1.343-2 3-2zM21 12c0 8-9 16-9 16S3 20 3 12a9 9 0 1118 0z"
          ></path>
        </svg>
      ),
      title: "100% Placement Assistance",
      description:
        "Benefit from our strong industry connections and dedicated support for job placements in Java roles.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
          ></path>
        </svg>
      ),
      title: "Experienced Instructor Panel",
      description:
        "Learn from seasoned Java developers with years of industry experience and teaching expertise.",
    },
    {
      icon: (
        <svg
          className="h-8 w-8 text-blue-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z"
          ></path>
        </svg>
      ),
      title: "Live Project & Case Study",
      description:
        "Gain invaluable experience by working on live projects and solving real-world case studies in Java.",
    },
  ];

  const [currentTestimonialIndex, setCurrentTestimonialIndex] = useState(0);

  useEffect(() => {
    const autoScrollInterval = setInterval(() => {
      setCurrentTestimonialIndex(
        (prevIndex) => (prevIndex + 1) % testimonials.length
      );
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(autoScrollInterval); // Clean up the interval
  }, [testimonials.length]);

  const goToPrevTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      prevIndex === 0 ? testimonials.length - 1 : prevIndex - 1
    );
  };

  const goToNextTestimonial = () => {
    setCurrentTestimonialIndex((prevIndex) =>
      (prevIndex + 1) % testimonials.length
    );
  };

  // Determine how many testimonials to show at once (e.g., 1 on small, 2 on medium, 3 on large)
  const getVisibleTestimonialsCount = () => {
    if (window.innerWidth >= 1024) return 3; // lg breakpoint
    if (window.innerWidth >= 768) return 2; // md breakpoint
    return 1; // default for small screens
  };

  const [visibleCount, setVisibleCount] = useState(
    getVisibleTestimonialsCount()
  );

  useEffect(() => {
    const handleResize = () => {
      setVisibleCount(getVisibleTestimonialsCount());
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const startIndex = currentTestimonialIndex;
  const endIndex =
    startIndex + visibleCount > testimonials.length
      ? testimonials.length
      : startIndex + visibleCount;
  const currentVisibleTestimonials = [];

  for (let i = startIndex; i < endIndex; i++) {
    currentVisibleTestimonials.push(testimonials[i]);
  }

  // Handle wrapping around for fewer than visibleCount items at the end
  if (
    currentVisibleTestimonials.length < visibleCount &&
    testimonials.length >= visibleCount
  ) {
    const remaining = visibleCount - currentVisibleTestimonials.length;
    for (let i = 0; i < remaining; i++) {
      currentVisibleTestimonials.push(testimonials[i]);
    }
  } else if (testimonials.length < visibleCount) {
    // If total testimonials are less than visible count, just show all
    currentVisibleTestimonials.push(...testimonials);
  }

  return (
    <div className="bg-white text-gray-800">
      <Helmet>
        <title>Java Certification Training in Noida | Core & Advanced Java Course</title>
        <meta
          name="description"
          content="Get certified in Java development in Noida. Our expert-led course covers Core Java, Advanced Java, OOPs concepts, and provides 100% placement assistance. Build real-world Java applications."
        />
        <meta
          name="keywords"
          content="Java certification Noida, Java course Noida, Core Java, Advanced Java, Java training, Java programming, Java placement, OOPS in Java, Java developer"
        />
      </Helmet>

      {/* Hero Section */}
      <section className="relative overflow-hidden text-white h-[400px] bg-gray-900 flex items-center">
        <img
          src="https://aiiits.com/assets/img/Java%20training-course.jpg"
          alt="Java Certification Background"
          className="absolute inset-0 w-full h-full object-cover z-0"
        />

        {/* Dark overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-60 z-10" />

        <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 md:py-40 flex flex-col md:flex-row items-center md:items-start">
          <div className="md:w-1/2">
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-4xl md:text-5xl font-extrabold leading-tight text-left"
            >
              <span className="text-orange-500">Java</span> Certification Training in Noida
            </motion.h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.8 }}
              className="mt-6 text-lg md:text-xl text-gray-200 text-left"
            >
              Become a certified Java developer with our comprehensive training program. Master Core and Advanced Java, build real-world projects, and secure top placements.
            </motion.p>

            <motion.button
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.6, duration: 0.8 }}
              className="mt-8 bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out"
            >
              <button
                    // className="bg-orange-600 hover:bg-orange-700 px-6 py-3 rounded-lg font-semibold transition text-white"
                    onClick={() => handleOpenPopup("Java Certification Course")} // Pass the course title
                  >
                     Enroll for Certification !
                  </button>
             
            </motion.button>
          </div>
        </div>
      </section>

      {/* Certification Highlights Section */}
      <section className="bg-gradient-to-r from-blue-50 to-indigo-50 py-16 px-4">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">
            Why Choose Our Java Certification?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {certificationDetails.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 flex flex-col items-center text-center"
              >
                <div className="mb-4">{item.icon}</div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-gray-700">{item.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Course Content / FAQ Section */}
      <section className="max-w-6xl mx-auto px-4 py-16 grid md:grid-cols-3 gap-10">
        <div className="md:col-span-2">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 text-center md:text-left">
            Frequently Asked Questions (FAQ) & Course Curriculum Highlights
          </h2>
          <div className="space-y-4">
            {faqContent.map((section, idx) => (
              <div
                key={idx}
                className="border border-gray-200 rounded-lg shadow-sm overflow-hidden bg-white"
              >
                <details className="group">
                  <summary className="cursor-pointer px-6 py-4 font-semibold text-lg bg-gray-50 hover:bg-gray-100 transition duration-200 ease-in-out flex justify-between items-center">
                    {section.title}
                    <span className="transform transition-transform duration-200 group-open:rotate-180">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </span>
                  </summary>
                  <div className="px-6 py-4 text-gray-700 leading-relaxed border-t border-gray-200">
                    <p>{section.answer}</p>
                  </div>
                </details>
              </div>
            ))}
          </div>
        </div>

        {/* Enquiry Form */}
        <div className="md:col-span-1 pt-48">
          <div className="bg-blue-300 rounded-lg p-6 shadow-xl">
            <h3 className="text-2xl font-bold mb-4 text-center text-blue-800">
              Enquire Now
            </h3>
            <p className="text-center text-gray-600 mb-6">
              Fill out the form below to get more details about our Java certification program.
            </p>
            <form className="space-y-4">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="Course of Interest (e.g., Java Certification)"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="text"
                placeholder="College/University Name"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <input
                type="tel"
                placeholder="Phone Number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
              <button
                type="submit"
                className="w-full bg-blue-800 hover:bg-blue-700 text-white py-3 rounded-md font-semibold transition duration-300 ease-in-out shadow-md hover:shadow-lg"
              >
                GET CERTIFIED
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Testimonial Section - No Horizontal Scrollbar */}
      <section className="bg-blue-50 py-16">
        <div className="max-w-7xl mx-auto px-4 text-center relative">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-blue-900">
            Our Students Say
          </h2>

          <div className="relative overflow-hidden w-full mx-auto">
            {/* Left Scroll Button */}
            <button
              onClick={goToPrevTestimonial}
              className="absolute left-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Previous testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M15 19l-7-7 7-7"
                ></path>
              </svg>
            </button>

            {/* Testimonial Cards Container */}
            <div className="flex justify-center items-stretch space-x-6 md:space-x-8 lg:space-x-10">
              <AnimatePresence mode="wait" initial={false}>
                {currentVisibleTestimonials.map((testimonial, idx) => (
                  <motion.div
                    key={testimonial.id} // Key by testimonial ID for consistent animation
                    initial={{ opacity: 0, x: idx * 100 }} // Initial position based on index in visible set
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -100 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                    className="flex-none w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-2rem)] p-2"
                    // w-[calc(50%-1.5rem)] means 50% width minus half of the space-x-6 (3rem total gap)
                    // w-[calc(33.333%-2rem)] means 33.333% width minus two-thirds of the space-x-6 (4rem total gap)
                  >
                    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 flex flex-col h-full text-left">
                      <div className="flex items-center mb-4">
                        <img
                          src={testimonial.profileImg}
                          alt={testimonial.name}
                          className="w-12 h-12 rounded-full object-cover mr-4 border-2 border-blue-200"
                        />
                        <div>
                          <p className="font-bold text-gray-900 text-lg">
                            {testimonial.name}
                          </p>
                          <p className="text-gray-500 text-sm">
                            {testimonial.date}
                          </p>
                        </div>
                      </div>
                      <div className="flex items-center mb-3">
                        <StarRating rating={testimonial.rating} />
                        {testimonial && <VerifiedBadge />}
                      </div>
                      <p className="text-gray-700 text-base leading-relaxed flex-grow line-clamp-4">
                        {testimonial.review}
                      </p>
                      <a
                        href="#"
                        className="text-blue-600 hover:underline mt-4 text-sm text-right"
                      >
                        Read more
                      </a>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Right Scroll Button */}
            <button
              onClick={goToNextTestimonial}
              className="absolute right-0 top-1/2 -translate-y-1/2 z-10 p-3 bg-white rounded-full shadow-lg hover:bg-gray-100 transition-colors duration-300 hidden md:block"
              aria-label="Next testimonial"
            >
              <svg
                className="w-6 h-6 text-gray-700"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 5l7 7-7 7"
                ></path>
              </svg>
            </button>
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, idx) => (
              <button
                key={idx}
                className={`h-3 w-3 rounded-full ${
                  // Logic to highlight dots based on the current set of visible testimonials
                  idx >= currentTestimonialIndex &&
                  idx < currentTestimonialIndex + visibleCount
                    ? "bg-blue-600"
                    : "bg-gray-300"
                } transition-colors duration-300`}
                onClick={() => setCurrentTestimonialIndex(idx)}
                aria-label={`Go to testimonial group ${idx + 1}`}
              ></button>
            ))}
          </div>
        </div>
      </section>

       {/* Conditionally render the popup */}
            {isPopupOpen && (
              <JoinNowFormPopup
                onClose={handleClosePopup}
                courseTitle={selectedCourseTitle}
              />
            )}
    </div>
  );
};

export default JavaCertification;